// Preserve localStorage for normal logins; use one tab-local snapshot when it
// is unavailable, so downstream reads cannot mix old and new credentials.
const FALLBACK_KEY = 'account_auth_session_fallback'
const AUTH_KEYS = ['token', 'access_token', 'user_id', 'redirectQuery', 'code']

const readFallback = () => {
  try {
    const value = JSON.parse(window.sessionStorage.getItem(FALLBACK_KEY))
    return value && value.version === 1 && value.values ? value.values : null
  } catch (error) {
    return null
  }
}

export const getAuthValue = key => {
  const fallback = readFallback()
  if (fallback) return fallback[key] == null ? null : fallback[key]
  try {
    return window.localStorage.getItem(key)
  } catch (error) {
    return null
  }
}

export const setAuthValues = values => {
  const fallback = readFallback()
  const snapshot = {}
  AUTH_KEYS.forEach(key => { snapshot[key] = getAuthValue(key) })
  Object.keys(values).forEach(key => { snapshot[key] = String(values[key]) })
  // Stay in this session once fallback starts. Switching back on a reload
  // could revive the stale credentials left in localStorage.
  if (!fallback) {
    try {
      Object.keys(values).forEach(key => window.localStorage.setItem(key, snapshot[key]))
      return
    } catch (error) {}
  }
  try {
    window.sessionStorage.setItem(FALLBACK_KEY, JSON.stringify({ version: 1, values: snapshot }))
  } catch (error) {
    throw new Error('Browser storage is unavailable')
  }
}
